'use client';

import { createContext } from 'react';

export const BUContext = createContext('');

export default function BusinessUnitProvider({ children, bu }: { children: React.ReactNode; bu: string }) {
	return <BUContext.Provider value={bu}>{children}</BUContext.Provider>;
}
